import isEmpty from "lodash.isempty";
import { paymentService } from "../services/payment";
import useEnv from "./useEnv";

const useSettings = () => {
    const { getEnv } = useEnv();

    const allowServing = typeof process.env.REACT_APP_SHOW_SERVING !== 'undefined' &&
        process.env.REACT_APP_SHOW_SERVING.toString() === '1';

    let preselectPayment = false;

    // check if bank selection modal can be shown in the environment (N.B. can be overridden if REACT_APP_NETAXEPT_PRESELECT_BANKS or REACT_APP_WORLDLINE_PRESELECT_BANKS contains banks)
    if (typeof process.env.REACT_APP_PRESELECT_PAYMENT !== 'undefined' && process.env.REACT_APP_PRESELECT_PAYMENT.toString() === '1') {
        preselectPayment = true;
    }

    /**
     * Helper for checking if the visibility of the bank selection modal needs to be changed.
     */
    const checkModalVisibilityOverrides = () => {
        if (!preselectPayment && paymentService.paymentService === paymentService.PAYMENTMETHODS.TINK) {
            // override preselect payment modal setting from false to true, if Netaxept or Worldline banks have been defined in an environment where bank selection modal is disabled (user chooses between Nets/Worldline banks (redirects to chosen bank in Nets/Worldline) or 'Online banks' (redirected to Tink))
            preselectPayment = true;
            redirectToTinkForPayment = true; // redirect to Tink for payment method selection instead of showing Tink's banks in MyRopo
        }
    }

    let includedNetsBanks = [];
    let redirectToTinkForPayment = false;

    // check if there are any banks from Netaxept that should be included in the payment method selection
    if (typeof process.env.REACT_APP_NETAXEPT_PRESELECT_BANKS !== 'undefined' && !isEmpty(process.env.REACT_APP_NETAXEPT_PRESELECT_BANKS)) {
        includedNetsBanks = process.env.REACT_APP_NETAXEPT_PRESELECT_BANKS.replace(' ', '').split(',');
        
        // check if visibility of the bank selection modal needs to be changed
        checkModalVisibilityOverrides();
    }

    let includedWorldlineBanks = [];
    const worldlinePreselectBanks = getEnv('WORLDLINE_PRESELECT_BANKS');

    // check if there are any banks from Worldline that should be included in the payment method selection
    if (worldlinePreselectBanks && worldlinePreselectBanks.trim() !== '') {
        includedWorldlineBanks = worldlinePreselectBanks.replace(' ', '').split(',');
        
        // check if visibility of the bank selection modal needs to be changed
        checkModalVisibilityOverrides();
    }

    let showFiresafety = true;

    // check if firesafety is set and show firesafety if value is 1
    if (typeof process.env.REACT_APP_CONFIRM_FIRESAFETY !== 'undefined' && process.env.REACT_APP_CONFIRM_FIRESAFETY.toString() === '0') {
        showFiresafety = false;
    }

    let paymentlimit = 0;

    // check if there is an allowed maximum amount for an invoice's open amount that can still be paid in MyRopo
    if (typeof process.env.REACT_APP_PAYMENT_LIMIT !== 'undefined' && process.env.REACT_APP_PAYMENT_LIMIT > 0) {
        paymentlimit = parseFloat(process.env.REACT_APP_PAYMENT_LIMIT);
    }

    const showChatButton = typeof process.env.REACT_APP_SHOW_CHAT !== 'undefined' && process.env.REACT_APP_SHOW_CHAT.toString() === '1';
    const showMessageCenterButton = typeof process.env.REACT_APP_MESSAGECENTER !== 'undefined' && process.env.REACT_APP_MESSAGECENTER.toString() === '1';

    return {
        allowServing,
        preselectPayment,
        redirectToTinkForPayment,
        includedNetsBanks,
        includedWorldlineBanks,
        showFiresafety,
        paymentlimit,
        showChatButton,
        showMessageCenterButton
    }
}

export default useSettings;
